import { render, staticRenderFns } from "./StudioBooking.vue?vue&type=template&id=b0b475c2&"
import script from "./StudioBooking.vue?vue&type=script&lang=js&"
export * from "./StudioBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports